import React from 'react';
import { If, Then, Else } from 'react-if';
import { useSelector } from 'react-redux';
import SpinnerBounce from './SpinnerBounce';

const Spinner = () => {
  const enabled = useSelector(({ui}) => ui.spinner);
  return (
    <If condition={enabled > 0}>
      <Then>
        <div className="mask">
          <SpinnerBounce />
        </div>
      </Then>
      <Else>
        <div className="mask hide">
          <div className="spinner">                            
          </div>
        </div>
      </Else>
    </If>
  );
};

export default Spinner;